<template>
  <svg :class="className">
    <use :xlink:href="iconId"></use>
  </svg>
</template>

<script>
export default {
  name: 'Svg',
  props: {
    iconId: String,
    className: String
  },
}
</script>